import React from "react";
import Link from "next/link";
import config from "@/config";

interface TopBarProps {
    topBarStatus?: string;
    text?: string;
    bgColor?: string;
    textColor?: string;
    hrefURl?: string;
    backgroundImagePath?: string;
}

const TopBarComponent: React.FC<TopBarProps> = React.memo(
    ({topBarStatus, text, bgColor, textColor, hrefURl, backgroundImagePath}) => (
        <Link
            href={`${hrefURl}`}
            className={`w-full md:absolute md:top-0 ${
                topBarStatus === "on" ? "" : ""
            } h-[50px] md:h-[68px] p-2 flex justify-center items-center right-0 overflow-hidden`}
            style={{
                backgroundColor: !backgroundImagePath ? bgColor : undefined,
                color: textColor,
                backgroundImage: backgroundImagePath ? `url(${config.baseUrl}${backgroundImagePath})` : undefined,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
            }}
        >
            <>
                <div className="whitespace-nowrap w-full overflow-hidden">
                    <strong className="md:flex inline-block animate-marquee">
                        {text || ""}
                    </strong>
                </div>
            </>
        </Link>
    )
);

export default TopBarComponent;

TopBarComponent.displayName = "TopBarComponent";